import React from 'react';
import './Scenario1.css';
import ReactPlayer from 'react-player';

const Scenario1Video3 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/ooOJBEBC35s' controls={true} />
        </div>
    );
}

export default Scenario1Video3;